import { Card, CardBody, Col } from "reactstrap";
import { StatusIndicator } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { STATUS_DATA, STATUS_INDICATOR } from "../../../../Data/UiKit/Avatars";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const StatusIndicatorCart = () => {
  return (
    <Col xl="4" md="6">
      <Card className="height-equal">
        <CommonCardHeader title={StatusIndicator} span={STATUS_DATA} />
        <CardBody className="avatar-showcase">
          <div className="avatars">
            <div className="avatar">
              <Image className="img-100 rounded-circle" src={dynamicImage("user/1.jpg")} alt="image" />
              <div className="status status-online"></div>
            </div>
            {STATUS_INDICATOR.map(({ className, src }, index) => (
              <div className="avatar" key={index}>
                <Image className={`${className} rounded-circle`} src={src} alt="image" />
                <div className="status status-dnd"></div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StatusIndicatorCart;
